import Vue from 'vue'

Vue.component('cmp-kti-talent-filter', require('./cmp-kti-talent-filter.vue').default)
